import script from "./ReportCreationPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReportCreationPage.vue?vue&type=script&setup=true&lang=ts"

import "./ReportCreationPage.vue?vue&type=style&index=0&id=7b0feac8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b0feac8"]])

export default __exports__